module.exports = __webpack_public_path__ + "static/media/A28i-Euro2020-guide.d06ceffc.pdf";